<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "tradeActivity"
    }
</script>

<style scoped>

</style>